const feedbackBarWidth = 400;
const feedbackBarWidthPixels = `${feedbackBarWidth}px`;

export { feedbackBarWidth, feedbackBarWidthPixels };
